import React, { Component } from 'react'
import MemoDetail from './MemoDetail'
import Alert from '../etc/Alert'
import Reader from '../../controller/Reader'
import Creater from '../../controller/Creater'

export default class MemoCol extends Component {
 
    constructor(props) {
        super(props)
        this.state = {
            memos: [],
            idName: '',
            detailOpen: false,
            isAlert: false
        }
    }


    componentDidMount() {

        this.getFx()

    }


    getFx = () => {
        
        const condition = {
            url : '/api/memo/list/' + this.props.catg2
        }

        Reader(condition, res => {

            if(res.data !== null) {

                this.setState({
                    memos : res.data
                })

            }
        })
    }


    detailFx = (e) => {
    
        if(!this.props.isLogin) {
            this.setState({ isAlert : true })
            return
        }
        
    	if(e.target.className === 'MemoCol') {
	        this.setState(
	            { detailOpen : true, 
                idName : e.target.id }
        	)
        } else {
            this.setState(
                { detailOpen : true, 
                idName : e.target.parentElement.id }
            )
        }
    }

    addFx = async () => {

        if(!this.props.isLogin) {
            this.setState({ isAlert : true })
            return
        }

        let condition = {
            url : '/api/memo/post',
            data : {
                catg1: this.props.catg1,
                catg2: this.props.catg2,
                title: 'Title',
                content: 'Description',
                heart: false,
                upload: ''
            }
        }

        await Creater(condition, res => {
            this.setState(
                { detailOpen : true,
                idName : res.data
                }
            )
        })

    }

    closeFx = () => {
        this.setState(
            { detailOpen : false,
            isAlert : false }
        )
    }


    render() {

        let filterVal = (item) => {

            switch(this.props.catg1) {

                case 'business' :
                return item.catg1 === 'business'
                
                case 'learning' :
                return item.catg1 === 'learning'
                
                case 'personal' :
                return item.catg1 === 'personal'
                
                default :
                return item.catg1 === 'business'
            }
        }

        let filterResult = this.state.memos.filter(filterVal)
            
        let memoBox = filterResult.map((poo) => {            
                
            const shortTitle = poo.title.slice(0, 50)
            const idName = poo._id
            const heart = poo.heart
            const upload = poo.upload
            
            
            return (
                <div className='MemoCol' id={idName} onClick={this.detailFx}>
                    <div className='MemoTitle'>{shortTitle}</div>
        
                    <div className='MemoBtn'>
                        <i className='material-icons' style={{ color: heart ? '#3E2D1F': null}}>favorite</i>
                        <i className='material-icons' style={{ color: upload !== '' ? '#3E2D1F': null}}>cloud_download</i>
                    </div>
                </div>
            )
        })


        return (

            <React.Fragment>

                { this.state.isAlert ? <Alert alert='Access Denied' closeMe = { this.closeFx } /> : null }

                <div className='MemoSubCatgWrap'>
                
                    { memoBox }
            
                </div>

                <div className='MemoAdd' onClick={this.addFx}>+ Add another card</div>

                {this.state.detailOpen === true ? <MemoDetail idName={this.state.idName} closeMe={this.closeFx} isLogin={this.props.isLogin} /> : null}

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/memo/MemoCol.js